<template>
    <div>
        <settings-property>
            <template #label>
                <v-select
                    class='form-control'
                    v-model="audienceSelectionModel"

                    :options="audienceSelectionOptions"
                    :disabled="!canWrite"
                    :clearable="false"

                    close-on-select
                />
            </template>
            
            <template #input>
                <input v-if="isNewAudience"
                       class='form-control'
                       v-model="newAudienceNameModel"
                       type="text"
                       
                       :disabled="!canWrite"
                />
                <v-select v-else
                          class='form-control'
                          v-model="existingAudienceModel"

                          label="name"

                          :options="audiences"
                          :disabled="!canWrite || !audiences.length"

                          clearable
                          searchable
                          filterable
                          taggable

                          close-on-select
                />
            </template>
        </settings-property>
    </div>
</template>

<script>
import api from "@modules/JourneyBuilder/api";
import {bootstrapDangerGrowl} from "@core/Util/growler";

import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';
import resourceMixin from '@core/Util/Mixins/resources';

import SettingsProperty from "../SettingsProperty";
import VSelect from 'vue-select';

const NEW_AUDIENCE = Symbol('NEW_AUDIENCE');
const EXISTING_AUDIENCE = Symbol('EXISTING_AUDIENCE');

export default {
    name: "GoalAudienceSettings",
    
    components: {
        SettingsProperty,
        VSelect
    },
    
    mixins: [permissionsMixin, resourceMixin],
    
    props: {
        isNewAudience: {
            type: Boolean,
            required: false
        },
        
        newAudienceName: {
            type: String,
            required: false
        },
        
        audienceId: {
            type: String,
            required: false
        }
    },
    
    data() {
        return {
            audienceSelectionOptions: [{
                label: this.resource('JourneyBuilder_GoalSettings_AudienceSettings_NewAudience'),
                id: NEW_AUDIENCE
            }, {
                label: this.resource('JourneyBuilder_GoalSettings_AudienceSettings_ExistingAudience'),
                id: EXISTING_AUDIENCE
            }],
            
            /** @type {{ id: String, name: String }[]} */
            audiences: []
        }
    },
    
    computed: {
        audienceSelectionModel: {
            get() {
                const selectedOption = this.isNewAudience ? NEW_AUDIENCE : EXISTING_AUDIENCE;
                return this.audienceSelectionOptions.find(opt => opt.id === selectedOption);
            },
            set(value) {
                this.$emit('update:newAudienceName', undefined);
                this.$emit('update:audienceId', undefined);
                this.$emit('update:isNewAudience', value.id === NEW_AUDIENCE);
            }
        },
        
        newAudienceNameModel: {
            get() {
                return this.newAudienceName
            },
            set(value) {
                //Emit an undefined value for empty strings
                this.$emit('update:newAudienceName', value || undefined);
            }
        },
        
        existingAudienceModel: {
            get() {
                return this.audiences.find(a => a.id === this.audienceId);
            },
            set(value) {
                this.$emit('update:audienceId', (value && value.id) || undefined);
            }
        }
    },
    
    async created() {
        try {
            this.audiences = await api.getAudiences();
        } catch (e) {
            bootstrapDangerGrowl(e);
        }
    }
}
</script>
